import { Directive, ElementRef, HostListener, Input } from "@angular/core";
import { NgControl, ControlValueAccessor } from '@angular/forms';
import { isNullOrUndefined } from './objectUtils';

@Directive({
    selector: "select[nullableSelect]",
    standalone: false
})
export class NullableSelectDirective {

  private valueAccessor: NullableSelectValueAcessor;

  constructor(private ngControl: NgControl) {
    if (ngControl === undefined)
      return;
    this.ngControl.valueAccessor = this.valueAccessor = new NullableSelectValueAcessor(this.ngControl.valueAccessor);
  }
}

class NullableSelectValueAcessor implements ControlValueAccessor {

  private propagateChange = (_: unknown) => { };

  private onControlChange = (value: unknown) => {
    const translatedValue = value == undefined || value == 'undefined' || isNullOrUndefined(value) ? undefined : value;
    this.propagateChange(translatedValue);
  }

  constructor(private innerAccessor: ControlValueAccessor) {
    this.innerAccessor.registerOnChange(this.onControlChange);
  }

  writeValue(obj: unknown): void {
    if (obj === null) {
      obj = undefined;
    }
    this.innerAccessor.writeValue(obj);
  }
  registerOnChange(fn: unknown): void {
    this.propagateChange = fn as any;
  }
  registerOnTouched(fn: unknown): void {
    this.innerAccessor.registerOnTouched(fn);
  }
  setDisabledState(isDisabled: boolean): void {
    this.innerAccessor.setDisabledState(isDisabled);
  }
}
